import { MAP_TYPES } from '@deck.gl/carto';

const RENTBURDENDIFF_SOURCE_ID = 'rentBurdenDiffSource';

const source = {
  id: RENTBURDENDIFF_SOURCE_ID,
  type: MAP_TYPES.TILESET,
  connection: 'bmpo-smartmetro-09142026',
  data: 'us-con-gcp-npr-0000424-011325.bmpo_curated_dev.BMPO_tileset_03',
};

export default source;
